import * as React from "react";
import { useSelect, Color } from "@hubper/theme";

type Props = {
  style?: React.CSSProperties;
  className?: string;
  size?: number;
  c?: Color | string;
};

function Spinner({
  size = 16,
  c = "currentColor",
  style = {},
  className
}: Props) {
  const { color } = useSelect();

  return (
    <svg
      style={{
        ...style,
        overflow: "visible"
      }}
      width={size}
      height={size}
      viewBox="-4 -4 40 40"
      xmlns="http://www.w3.org/2000/svg"
      stroke={Array.isArray(c) ? color(c) : c}
      className={className}
    >
      <g fill="none" fillRule="evenodd">
        <g transform="translate(1 1)" strokeWidth="6">
          <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
          <path d="M36 18c0-9.94-8.06-18-18-18">
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 18 18"
              to="360 18 18"
              dur=".75s"
              repeatCount="indefinite"
            />
          </path>
        </g>
      </g>
    </svg>
  );
}

export default Spinner;
